import { BackArrowIcon } from '../../assets/icons/back-arrow.tsx';
import { IconButton, type IconButtonProps } from './Button.tsx';
import { useTheme } from '@mui/material';


export const PageBackButton = (props: IconButtonProps) => {
  const { sx, ...rest } = props;
  const { palette } = useTheme();
  return (
    <IconButton sx={{ color: palette.dark, ...sx }} {...rest}>
      <BackArrowIcon />
    </IconButton>
  );
};
